import { http_client } from '@/plugins/http_client';

const API_BASE = '/api/consultorias';

export const fetchDetalleEntregableProrroga = (id, params = {}) => {
  return http_client(`${API_BASE}/entregables/filtrar/${id}`, params, 'POST');
};

export const actualizarConsultoriaProrroga = (id, params = {}) => {
  return http_client(
    `${API_BASE}/mnt/consultorias/${id}/prorroga`,
    params,
    'POST'
  );
};

export const guardarProrroga = (id, params = {}) => {
  return http_client(`${API_BASE}/entregables/prorroga/${id}`, params, 'POST');
};

export default {
  fetchDetalleEntregableProrroga,
  guardarProrroga,
  actualizarConsultoriaProrroga,
};
